// Define an action for toggling the theme
export const toggleTheme = () => ({
    type: 'TOGGLE_THEME',
  });
  
  export const setLightTheme = () => ({
    type: 'SET_LIGHT',
  });